import bigDataLog from '@/utils/bigDataLog'
import {
    addCarInfo,
    editCarInfo,
    addCarInfoPrivilege,
    editCarInfoPrivilege,
    singleVehicle,
    copyVehicle,
    getVehicleApproveDetail,
} from '../../../../../../api/register/vehicle.js'
import { supplierDriverCarApprovalInfo } from '../../../../../../api/register/driver.js'
import { vehiclePublicForm } from './formdataAndRules.js'
import { COMPANY } from '../../../../../../constant/constant.js'
import dayjs from 'dayjs'
export default {
    dealWithOpenLogic() {
        // 存在试点且是法人供应商才展示新版页面
        const isSupplier = this.$store.state.supplier
        const propertyNature = isSupplier ? isSupplier.propertyNature : this.supplierTab.propertyNature
        this.isLegalPersonSupplier = propertyNature === COMPANY
        // this.isNewUploadVersion = this.isLegalPersonSupplier;
        // this.isNewUploadVersion = true;
        this.handleJudge(this.id)
    },
    // // 切换新旧版显示
    // switchVersion() {
    //     this.isNewUploadVersion = !this.isNewUploadVersion;
    // },
    // 预览文件
    handlePreviewFile(obj) {
        this.rowData = obj.rowData
        this.attachmentList = obj.allAttachmentList
        this.attachmentShow = true
    },
    // 新版提交， needExamine 是否需要审批
    handleSubmit(params, needExamine = false) {
        params.carDrivingEndTime = params.carDrivingEndTime
            ? dayjs(params.carDrivingEndTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
        params.roadTransportEndTime = params.roadTransportEndTime
            ? dayjs(params.roadTransportEndTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
        params.affiliatedEndTime = params.affiliatedEndTime
            ? dayjs(params.affiliatedEndTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
            params.trafficInsuranceEndTime = params.trafficInsuranceEndTime
                ? dayjs(params.trafficInsuranceEndTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            params.businessInsuranceEndTime = params.businessInsuranceEndTime
                ? dayjs(params.businessInsuranceEndTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
        // 若是供应商端，供应商编码拿当前账号登录的供应商编码
        params.supplierCode = this.isSupplier ? this.$store.state.supplier.supplierCode : params.supplierCode

        params.paramFieldList.forEach(v => {
            v.afterValue = params[v.fieldName]
        })
        // console.log(JSON.stringify(params.paramFieldList),'5=5=5=5=5=')
        // return
        this.loading = true
        const reqMethod = needExamine
            ? params.relationId
                ? editCarInfo
                : addCarInfo
            : params.relationId
                ? editCarInfo
                : addCarInfo
        reqMethod(params)
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleRecover()
                }else if(res && res.code === 'LSRM25081402'){
                    this.$alert(res.msg, '提示', {
                        customClass: 'submit-warn-dialog',
                    });
                }
            })
            .finally(() => {
                this.loading = false
            })
    },
    // 提交
    handleNewVersionSubmit() {
        this.$refs.newUploadVersion.validateForm(this.handleSubmit)
        bigDataLog.sendDetailMessageByKey('bigData-btn-v-submitNew')
    },
    // 处理新版页面一些逻辑
    dealWithNewUploadVersionPageLogic() {
        if (this.$refs.newUploadVersion) {
            this.$refs.newUploadVersion.resetForm() // 重置表单数据
        }
    },
    // 如果是新版页面
    newUploadVersionInitData() {
        // isNewUploadVersion 已弃用，无需再进行判断
        // if (this.isNewUploadVersion) {
        //     this.$refs.newUploadVersion.isApprove = this.approve;
        //     this.$refs.newUploadVersion.initFormData(this.form);
        // }
        this.$refs.newUploadVersion.isApprove = this.approve
        this.$refs.newUploadVersion.initFormData(this.form)
    },
    // 获取审批详情数据
    getApproveDetail(id) {
        this.title = '审批详情'
        getVehicleApproveDetail(id).then(res => {
            if (res && +res.code === 0) {
                [
                    'approvalUserName',
                    'approvalStatus',
                    'commitTime',
                    'approvalOpinion',
                    'approvalTime',
                    'commitUserCode',
                    'headquartersApprovalName',
                    'fdId',
                ].forEach(k => {
                    this.approveInfo[k] = res.data[k]
                })
                this.approveInfo.approvalStatusText = this.dict['SRM_AUDIT_STATUS'][res.data.approvalStatus]
                this.approveInfo.auditTypeText = this.dict['SRM_CAR_AUDIT_TYPE'][res.data.auditType]
                this.approveInfo.createSystemSourceText = this.dict['SRM_REGISTER_SOURCE'][res.data.createSystemSource]
                this.approveInfo.approvalModeText = this.dict['SRM_DRIVER_CAR_APPROVAL_MODE'][res.data.approvalMode]
                this.approveInfo.businessTypeText = this.dict['SRM_BUSYNESS_TYPE_BACKGROUND'][res.data.businessType]
                this.form = res.data
                // 法人供应商
                if (this.isLegalPersonSupplier) {
                    this.form.delegateOnline = this.form.delegateOnline || '1'
                }
                this.handleGetAllAttachmentList()
                if (this.$refs['form']) {
                    this.$refs['form'].resetFields()
                }
                this.newUploadVersionInitData()
                this.supplierDriverCarApprovalInfo()
            }
        })
    },
    supplierDriverCarApprovalInfo(){
        this.$set(this.approveInfo, '_approvalName', '' )
        this.$set(this.approveInfo, '_headquartersApprovalName', '' )
        if(this.approveInfo.fdId){
            supplierDriverCarApprovalInfo(this.approveInfo.fdId).then(res => {
                if (res && res.code === '0') {
                    this.$set(this.approveInfo, '_approvalName', res.data.approvalName )
                    this.$set(this.approveInfo, '_headquartersApprovalName', res.data.headquartersApprovalName )
                }
            })
        }
    },
    // 获取编辑详情数据
    getEditDetail(id) {
        this.title = '编辑'
        singleVehicle(id).then(res => {
            this.form = res.data
            this.handleGetAllAttachmentList()
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
            }
            this.setOcrData(res.data)
            this.newUploadVersionInitData()
        })
    },
    // 特权复制
    getCopyVehicle(id) {
        this.title = '特权复制'
        copyVehicle(id).then(res => {
            this.form = res.data
            this.handleGetAllAttachmentList()
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
            }
            this.setOcrData(res.data)
            this.newUploadVersionInitData()
        })
    },
    handleJudge(id) {
        if (this.approve) {
            this.getApproveDetail(id)
        } else if (id && !this.copy && !id.includes('_')) {
            this.getEditDetail(id)
        } else if (id && this.copy) {
            this.getCopyVehicle(id)
        } else {
            this.title = '新增'
            this.form = JSON.parse(JSON.stringify(vehiclePublicForm))
            this.form.supplierCode = this.supplierCode_
            this.$nextTick(() => {
                this.$refs.newUploadVersion.initFormData(this.form)
            })

        }
    },
}
